import React from 'react';

const AllReviews = () => {
    return (
        <div>
            <h2>All Reviews</h2>
        </div>
    );
};

export default AllReviews;